import { render } from "./PageTournaments.vue?vue&type=template&id=d0b89568"
import script from "./PageTournaments.vue?vue&type=script&lang=js"
export * from "./PageTournaments.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__